<template>
    <div class="feed">

        <div class="feed-post card">

            <!-- Unlock Post Button -->
            <div v-if="post.privacy === 'pay_to_view'" class="d-flex flex-column d-sm-block p-3 rounded-top text-muted text-center text-sm-left" style="background-color: #edf2f7;">
                <template v-if="post.is_unlocked">
                    <div class="d-inline-block"><i class="fa fa-lock-open"></i> You have Unlocked this Premium post.</div>
                </template>
                <template v-else>
                    <div class="d-block d-sm-inline-block align-middle mb-2 mb-sm-0"><i class="fa fa-lock"></i> This is a Premium post.</div>
                    <button :id="'post-' + post.id + '-unlock-button'" type="button" @click="unlockPost" class="d-block d-sm-inline-block btn btn-sm rounded btn-secondary float-sm-right flex-fill">
                        <i class="fa fa-lock-open"></i> Unlock for ${{ post.price }}
                    </button>
                </template>
            </div>

            <!-- Subscribe for Post Button -->
            <div v-if="post.privacy === 'subscribers_only'" class="d-flex flex-column d-sm-block p-3 rounded-top text-muted text-center text-sm-left" style="background-color: #edf2f7;">
                <template v-if="post.is_membership_active">
                    <div class="d-inline-block"><i class="fa fa-star"></i> You're a Subscriber! Enjoy this Subscribers Only post.</div>
                </template>
                <template v-else>
                    <div class="d-block d-sm-inline-block align-middle mb-2 mb-sm-0" style="align-self:center;"><i class="fa fa-user-lock"></i> This is a Subscribers Only post.</div>
                    <button :id="'post-' + post.id + '-subscribe-button'" type="button" @click="showSubscriptionOptionsModal" class="d-block d-sm-inline-block btn btn-sm rounded btn-secondary float-sm-right flex-fill">
                        <i class="fa fa-star"></i> Subscribe Now
                    </button>
                </template>
            </div>

            <!-- User and Dropdown -->
            <div class="card-header card-header-fluid">
                <div class="btn-account" role="button" style="min-width:0;">
                    <a :href="post.user.public_profile_url" class="user-avatar user-avatar-lg bg-gray">
                        <img :src="post.user.profile_image_url" alt="">
                    </a>
                    <div class="account-summary" style="align-self:auto;">
                        <a :href="post.user.public_profile_url" class="account-name text-reset text-wrap" style="line-height:1.2;">{{ post.user.display_name }}</a>
                        <p class="account-description" style="white-space:normal">
                            <a :href="post.user.public_profile_url" class="text-reset">@{{ post.user.username }}</a>
                            <span v-if="post.user.is_verified">
                                <i class="fa fa-sm fa-check-circle text-success" data-toggle="tooltip" title="Verified"></i>
                            </span>
                            <span>·</span>
                            <span :title="post.published_at_formatted" data-toggle="tooltip">{{ post.published_at_diff }}</span>
                            <span v-if="showPinnedPostBadge && post.is_pinned">·</span>
                            <span v-if="showPinnedPostBadge && post.is_pinned" class="badge bg-dark text-light">
                                <i class="fas fa-thumbtack"></i> Pinned
                            </span>
                        </p>
                    </div>
                </div>
                <div class="ml-auto d-flex">
                    <div v-if="showFollowButton" class="my-auto mr-1">
                        <div v-if="post.is_following" @click="unfollowUser" class="cursor-pointer badge badge-success p-2">
                            <span>Following</span>
                        </div>
                        <div v-else @click="followUser" class="cursor-pointer badge badge-subtle badge-secondary text-success border border-success p-2">
                            <i class="fa fa-plus"></i>
                            <span>Follow</span>
                        </div>
                    </div>
                    <div class="dropdown my-auto">
                        <button class="btn btn-icon btn-light text-muted" data-toggle="dropdown">
                            <i class="fa fa-fw fa-ellipsis-v"></i>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">

                            <div class="dropdown-arrow"></div>
                            <button class="dropdown-item clipboardjs" :data-clipboard-text="route('public-profile.post', [post.user.username, post, post.slug])">Copy Link</button>

                            <div v-if="post.user.id === viewerId" class="dropdown-divider"></div>
                            <a v-if="post.user.id === viewerId" class="dropdown-item" :href="route('dashboard.posts.edit', post)">Edit</a>
                            <button v-if="post.user.id === viewerId && !post.is_pinned" type="button" class="dropdown-item" @click="pinPost">Pin</button>
                            <button v-if="post.user.id === viewerId && post.is_pinned" type="button" class="dropdown-item" @click="unpinPost">Unpin</button>
                            <button v-if="post.user.id === viewerId" type="button" class="dropdown-item" @click="deletePost">Delete</button>

                            <div class="dropdown-divider"></div>
                            <button v-if="showHidePostButton" type="button" class="dropdown-item" @click="hidePost">Hide this Post</button>
                            <button v-if="showHideUserButton" type="button" class="dropdown-item" @click="hideUser">Hide @{{ post.user.username }}</button>
                            <button type="button" class="dropdown-item" @click="showReportPostModal">Report Post</button>

                        </div>
                    </div>
                </div>
            </div>

            <div class="card-body">

                <!-- unlocked content -->
                <div v-if="post.privacy === 'public' || post.is_unlocked || (post.privacy === 'subscribers_only' && post.is_membership_active)">

                    <!-- text -->
                    <div v-if="post.has_text" :class="{ 'mb-2': post.media.length > 0 }">
                        <div class="mb-0 readmorejs" v-html="linkifyHtml(post.html)"></div>
                    </div>

                    <!-- media -->
                    <div v-if="post.media.length > 0" class="row m-n1">
                        <div v-for="media in orderedMedia" :key="media.id" :class="postColumnSizeClass">
                            <div class="card-figure p-0">
                                <figure class="figure bg-gray rounded">
                                    <a v-if="fnmatch('image/*', media.mime)" href="javascript:void(0)" :data-src="media.url" class="square img-fluid rounded" :style="{ 'background-image': 'url(' + media.thumbnail_url + ')' }" :data-fancybox="`gallery-post-${post.id}`">
                                        <img :src="media.thumbnail_url" style="display:none;" alt=""/>
                                    </a>
                                    <a v-else-if="fnmatch('video/*', media.mime)" href="javascript:void(0)" :data-src="'#video-' + media.id" :data-width="media.video_width" :data-height="media.video_height" class="square img-fluid rounded" :style="{ 'background-image': 'url(' + media.thumbnail_url + ')' }" :data-fancybox="`gallery-post-${post.id}`">
                                        <video :id="`video-${media.id}`" loop="loop" controls controlsList="nodownload" style="display:none;" :poster="media.thumbnail_url">
                                            <source :src="media.url" type="video/mp4"/>
                                        </video>
                                        <div class="mx-auto my-auto video-play-icon shadow rounded">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                                                <path fill="currentColor" d="M78.158 51.843L25.842 82.048c-1.418.819-3.191-.205-3.191-1.843v-60.41c0-1.638 1.773-2.661 3.191-1.843l52.317 30.205c1.418.819 1.418 2.867-.001 3.686z"/>
                                            </svg>
                                        </div>
                                    </a>
                                </figure>
                            </div>

                        </div>
                    </div>

                </div>

                <!-- locked content -->
                <div v-else>

                    <div v-if="post.has_preview_text" class="bg-light p-2 rounded mb-2">
                        <small class="text-muted">Post Preview</small>
                        <p class="mb-0 readmorejs" v-html="linkifyString(post.preview_text)"></p>
                    </div>

                    <div v-if="post.has_text" class="bg-light p-2 rounded mb-2">
                        <small class="text-muted"><i class="fa fa-lock"></i> This Text is Locked</small>
                        <div class="text-muted">
                            <a v-if="post.privacy === 'pay_to_view'" href="javascript:void(0)" @click="unlockPost">Unlock to See More</a>
                            <a v-else-if="post.privacy === 'subscribers_only'" href="javascript:void(0)" @click="showSubscriptionOptionsModal">Subscribe to See More</a>
                        </div>
                    </div>

                    <div v-if="post.media.length > 0" class="row m-n1">
                        <div v-for="(media, index) in orderedPreviewMedia" :key="media.id" :class="postColumnSizeClass">

                            <!-- locked media preview -->
                            <a href="javascript:void(0)" @click="onLockedMediaClick">
                                <div class="card-figure p-0">
                                    <figure class="figure justify-content-center bg-gray rounded">
                                        <div class="square img-fluid rounded" style="position:relative;" :style="{ 'background-image': 'url(' + media.preview_url + ')' }">
                                            <div class="d-flex text-center" style="position:absolute;top:0;bottom:0;left:0;right:0;z-index:1;text-shadow: #000000 0 0 2px;">
                                                <div class="mx-auto my-auto">
                                                    <div class="d-block mb-1">
                                                        <i class="fa fa-lock text-light"></i>
                                                    </div>
                                                    <template v-if="post.media.length > maxPreviewMediaToShow && index === maxPreviewMediaToShow - 1">
                                                        <span class="mb-1 text-light p-1 rounded align-middle" style="background:rgba(0, 0, 0, 0.25);">
                                                            <i class="fa fa-plus fa-sm"></i>
                                                            <span>{{ moreMediaCount }} More</span>
                                                        </span>
                                                    </template>
                                                    <template v-else-if="fnmatch('image/*', media.mime)">
                                                        <span class="d-sm-block d-none mb-1 text-light">Photo Locked</span>
                                                        <span class="mb-1 text-light p-1 rounded align-middle" style="background:rgba(0, 0, 0, 0.25);">
                                                            <i class="fa fa-camera fa-sm"></i> Photo
                                                        </span>
                                                    </template>
                                                    <template v-else-if="fnmatch('video/*', media.mime)">
                                                        <span class="d-sm-block d-none mb-1 text-light">Video Locked</span>
                                                        <span class="mb-1 text-light p-1 rounded align-middle" style="background:rgba(0, 0, 0, 0.25);">
                                                            <i class="fa fa-play fa-sm"></i>
                                                            <span>{{ media.video_duration >= 30 ? media.video_duration_human_formatted : 'Video' }}</span>
                                                        </span>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                    </figure>
                                </div>
                            </a>

                        </div>
                    </div>

                </div>

            </div>
            <div class="card-footer">
                <div class="row w-100 text-center mx-auto">

                    <!-- Like -->
                    <div class="col col-sm-auto">
                        <button type="button" class="btn btn-reset text-nowrap text-muted p-3" @click="togglePostLike">
                            <i v-if="post.is_liked" class="fa fa-fw fa-heart text-red"></i>
                            <i v-else class="fa fa-fw fa-heart-o"></i>
                            <span v-if="post.likes_count > 0">{{ post.likes_count }}</span>
                        </button>
                    </div>

                    <!-- Comment -->
                    <div class="col col-sm-auto">
                        <button type="button" @click="toggleComments" class="btn btn-reset text-nowrap text-muted p-3">
                            <i class="fa fa-fw fa-comment-o"></i>
                            <span v-if="post.comments_count > 0">{{ post.comments_count }}</span>
                            <span class="d-none d-sm-inline">Comments</span>
                        </button>
                    </div>

                    <!-- Tip -->
                    <div class="col col-sm-auto">
                        <button type="button" class="btn btn-reset text-nowrap text-muted p-3" @click="showTipOptionsModal(post.user.id, post.id)">
                            <i class="fa fa-fw fa-coins"></i>
                            <span class="d-none d-sm-inline">Tip</span>
                        </button>
                    </div>

                    <!-- Share -->
                    <div class="col col-sm-auto">
                        <div class="dropdown">
                            <a href="javascript:void(0)" class="btn btn-reset text-nowrap text-muted p-3" data-toggle="dropdown">
                                <i class="fa fa-fw fa-share"></i>
                                <span class="d-none d-sm-inline">Share</span>
                            </a>
                            <div class="dropdown-menu dropdown-menu-right">
                                <div class="dropdown-arrow"></div>
                                <button class="dropdown-item clipboardjs" :data-clipboard-text="route('public-profile.post', [post.user.username, post, post.slug])">Copy Link</button>
                                <div class="dropdown-divider"></div>
                                <a target="_blank" :href="'https://www.facebook.com/sharer/sharer.php?u=' + window.encodeURIComponent(route('public-profile.post', [post.user.username, post, post.slug]))" class="dropdown-item"><i class="fa fa-facebook-square text-facebook"></i> Facebook</a>
                                <a target="_blank" :href="'https://twitter.com/intent/tweet?text=' + window.encodeURIComponent(route('public-profile.post', [post.user.username, post, post.slug]))" class="dropdown-item"><i class="fa fa-twitter-square text-twitter"></i> Twitter</a>
                                <a target="_blank" :href="'https://www.reddit.com/submit?url=' + window.encodeURIComponent(route('public-profile.post', [post.user.username, post, post.slug]))" class="dropdown-item"><i class="fa fa-reddit-square text-red"></i> Reddit</a>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!-- Comments -->
        <template v-if="isShowingComments">
            <div v-if="post.comments_enabled" class="feed-comments card">
                <div role="log" class="conversations">
                    <ul class="conversation-list">

                        <!-- load more -->
                        <li v-if="!isLoadingComments && hasMoreComments">
                            <div>
                                <a href="javascript:void(0)" @click="loadMoreComments">Show older Comments</a>
                            </div>
                        </li>

                        <!-- loading spinner -->
                        <li v-if="isLoadingComments" class="d-flex">
                            <div class="mx-auto">
                                <i class="text-muted fa fa-2x fa-spinner-third fa-spin-fast"></i>
                            </div>
                        </li>

                        <li v-for="postComment in comments" :key="postComment.id" class="conversation-inbound">
                            <div class="conversation-avatar">
                                <a :href="postComment.user.public_profile_url" class="user-avatar bg-gray">
                                    <img :src="postComment.user.profile_image_url" alt="">
                                </a>
                            </div>
                            <div class="conversation-message w-100">
                                <div class="conversation-meta mb-0">
                                    <a :href="postComment.user.public_profile_url">@{{ postComment.user.username }}</a>
                                    <i v-if="postComment.user.is_verified" class="fa fa-sm fa-check-circle text-success" data-toggle="tooltip" title="Verified"></i>
                                    <span v-if="postComment.user.id === post.user.id" class="mention">Post Author</span>
                                    <small class="time ml-1" data-toggle="tooltip" :title="postComment.created_at_formatted">
                                        {{ postComment.created_at_diff }}
                                    </small>
                                    <div class="d-inline dropdown">
                                        <button class="btn btn-sm btn-icon btn-light text-muted" data-toggle="dropdown">
                                            <i class="fa fa-fw fa-ellipsis-h"></i>
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <div class="dropdown-arrow"></div>
                                            <button v-if="post.user.id === viewerId || postComment.user.id === viewerId" @click="deleteComment(postComment)" class="dropdown-item">Delete</button>
                                            <button type="button" class="dropdown-item" @click="showReportPostCommentModal(postComment)">Report Comment</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="conversation-message-text" v-html="linkifyString(postComment.text, 'hashtag,mention')"></div>
                                <div class="conversation-meta">
                                    <span v-if="postComment.likes_count > 0">
                                        <span @click="showPostCommentLikesModal(postComment)" style="cursor:pointer;">
                                            <span class="badge badge-subtle badge-dark">
                                            <i class="fa fa-thumbs-up"></i>
                                            <span>{{ postComment.likes_count }}</span>
                                            </span>
                                        </span>
                                        <span>•</span>
                                    </span>
                                    <a href="javascript:void(0)" @click="togglePostCommentLike(postComment)">
                                        <span v-if="postComment.is_liked">Unlike</span>
                                        <span v-else>Like</span>
                                    </a>
                                </div>
                            </div>
                        </li>

                        <!-- Add Comment -->
                        <li v-if="!isLoadingComments || comments.length > 0" :class="{ 'mt-3': isLoadingComments || comments.length > 0 }" class="conversation-action">

                            <!-- unlock to comment -->
                            <div @click="unlockPost" v-if="post.user.id !== viewerId && post.privacy === 'pay_to_view' && !post.is_unlocked" class="bg-light p-3 rounded cursor-pointer d-flex shadow-sm">
                                <div>
                                    <i class="fa fa-lock mr-1"></i> Unlock this post to be able to comment.
                                </div>
                                <div class="ml-auto">
                                    <i class="fa fa-caret-right"></i>
                                </div>
                            </div>

                            <!-- subscribe to comment -->
                            <div @click="showSubscriptionOptionsModal" v-else-if="post.user.id !== viewerId && post.privacy === 'subscribers_only' && !post.is_membership_active" class="bg-light p-3 rounded cursor-pointer d-flex shadow-sm">
                                <div>
                                    <i class="fa fa-lock mr-1"></i> Subscribe to be able to comment.
                                </div>
                                <div class="ml-auto">
                                    <i class="fa fa-caret-right"></i>
                                </div>
                            </div>

                            <!-- comment -->
                            <div v-else class="media">
                                <figure v-if="viewer" class="user-avatar mr-2 d-none d-md-block">
                                    <img :src="viewer.profile_image_url" alt="">
                                </figure>
                                <div class="media-body">
                                    <div class="publisher keep-focus focus">
                                        <div class="publisher-input">
                                            <textarea v-model="comment" name="text" class="form-control" placeholder="Write a comment" rows="4"></textarea>
                                        </div>
                                        <div class="publisher-actions">
                                            <button @click="createComment" type="submit" class="btn btn-secondary ml-auto">
                                                <span v-if="isCommenting">
                                                    <i class="fad fa-spin fa-spin-fast fa-spinner-third"></i>
                                                    <span>Commenting</span>
                                                </span>
                                                <span v-else>Comment</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </li>

                    </ul>
                </div>
            </div>
            <div v-else class="mx-2 mb-2 bg-light p-3 rounded">
                <i class="fa fa-comment-slash"></i> Comments are not enabled for this Post.
            </div>
        </template>

        <PostCommentLikesModalComponent ref="post-comment-likes-modal"/>
        <ReportContentModal ref="report-content-modal"/>
        <SubscriptionOptionsModalComponent ref="subscription-options-modal"/>
        <TipOptionsModalComponent ref="tip-options-modal"/>

    </div>
</template>

<script>
import _ from "lodash";
import PostCommentLikesModalComponent from "../PostCommentLikesModalComponent.vue";
import ReportContentModal from "../Report/ReportContentModal.vue";
import SubscriptionOptionsModalComponent from "../SubscriptionOptionsModalComponent.vue";
import TipOptionsModalComponent from "../TipOptionsModalComponent.vue";
export default {
    name: 'Post',
    props: [
        'post',
        'viewer',
        'showFollowButton',
        'showHideUserButton',
        'showHidePostButton',
        'showPinnedPostBadge',
    ],
    components: {
        PostCommentLikesModalComponent,
        ReportContentModal,
        SubscriptionOptionsModalComponent,
        TipOptionsModalComponent,
    },
    mounted: function() {

    },
    data: function() {
        return {

            window: window, // access window from vue template
            maxPreviewMediaToShow: 12,
            viewerId: this.viewer?.id,

            isShowingComments: false,
            isLoadingComments: false,
            isCommenting: false,
            hasMoreComments: true,
            commentsNextCursor: null,
            comments: [],
            comment: null,

        };
    },
    methods: {
        route: function(name, params) {
            return window.route(name, params);
        },
        fnmatch: function(glob, input) {
            const matcher = glob
                .replace(/\*/g, '.*')
                .replace(/\?/g, '.'); // Replace wild cards with regular expression equivalents
            const r = new RegExp(`^${ matcher }$`); // Match beginning and end of input using ^ and $
            return r.test(input);
        },
        checkAuthenticationAndThen: function(callback) {

            // we don't have a handler registered...
            if(!window.checkAuthenticationAndThen){
                callback();
                return;
            }

            // use authentication handler on public profile?
            window.checkAuthenticationAndThen(callback);

        },
        showTipOptionsModal: function(userId, postId) {
            this.checkAuthenticationAndThen(() => {
                this.$refs['tip-options-modal'].show(userId, postId);
            });
        },
        showSubscriptionOptionsModal: function() {
            this.checkAuthenticationAndThen(() => {
                this.$refs['subscription-options-modal'].show(this.post.user.id);
            });
        },
        showReportPostModal: function() {
            this.checkAuthenticationAndThen(() => {
                this.$refs['report-content-modal'].show(this.post.id, 'post');
            });
        },
        showReportPostCommentModal: function(postComment) {
            this.checkAuthenticationAndThen(() => {
                this.$refs['report-content-modal'].show(postComment.id, 'post_comment');
            });
        },
        showPostCommentLikesModal: function(postComment) {
            this.checkAuthenticationAndThen(() => {
                this.$refs['post-comment-likes-modal'].show(postComment.id);
            });
        },
        toggleComments: function() {
            if(this.isShowingComments){
                this.hideComments();
            } else {
                this.showComments();
            }
        },
        showComments: function() {
            this.comments = [];
            this.commentsNextCursor = null;
            this.hasMoreComments = false;
            this.isShowingComments = true;
            this.loadMoreComments();
        },
        hideComments: function() {
            this.isShowingComments = false;
        },
        loadMoreComments: function() {

            // do nothing if currently loading more
            if(this.isLoadingComments){
                return;
            }

            this.isLoadingComments = true;

            // fetch post comments
            axios.get(route('web-api.posts.comments', this.post), {
                params: {
                    order: 'latest',
                    cursor: this.commentsNextCursor,
                },
            }).then((response) => {

                // get json data from response
                const json = response.data;

                // update comment enabled state
                this.post.comments_enabled = json.comments_enabled;

                // add all results to list
                json.post_comments.data.forEach((comment) => {
                    this.comments.unshift(comment);
                });

                // check if we have more results
                if(json.post_comments.next_cursor){
                    this.hasMoreComments = true;
                    this.commentsNextCursor = json.post_comments.next_cursor;
                } else {
                    this.hasMoreComments = false;
                }

            }).catch((err) => {

                console.error(err);

                // show error message
                window.toastr.error("Something went wrong. Please try again.", null, {
                    positionClass: 'toast-bottom-right',
                });

            }).then(() => {

                // no longer loading
                this.isLoadingComments = false;

            });

        },
        togglePostLike: function() {
            if(this.post.is_liked){
                this.unlikePost();
            } else {
                this.likePost();
            }
        },
        likePost: function() {
            this.checkAuthenticationAndThen(() => {
                axios.post(route('web-api.posts.like', this.post.id)).then((response) => {
                    this.post.is_liked = true;
                    this.post.likes_count = response.data.likes;
                }).catch((error) => {
                    this.post.is_liked = false; // revert state so they can try again
                    this.showErrorMessage(error);
                });
            });
        },
        unlikePost: function() {
            this.checkAuthenticationAndThen(() => {
                axios.post(route('web-api.posts.unlike', this.post.id)).then((response) => {
                    this.post.is_liked = false;
                    this.post.likes_count = response.data.likes;
                }).catch((error) => {
                    this.showErrorMessage(error);
                });
            });
        },
        togglePostCommentLike: function(postComment) {
            if(postComment.is_liked){
                this.unlikePostComment(postComment);
            } else {
                this.likePostComment(postComment);
            }
        },
        likePostComment: function(postComment) {
            this.checkAuthenticationAndThen(() => {
                axios.post(route('web-api.posts.comments.like', postComment.id)).then((response) => {
                    postComment.is_liked = true;
                    postComment.likes_count = response.data.likes;
                }).catch((error) => {
                    postComment.is_liked = false; // revert state so they can try again
                    this.showErrorMessage(error);
                });
            });
        },
        unlikePostComment: function(postComment) {
            this.checkAuthenticationAndThen(() => {
                axios.post(route('web-api.posts.comments.unlike', postComment.id)).then((response) => {
                    postComment.is_liked = false;
                    postComment.likes_count = response.data.likes;
                }).catch((error) => {
                    this.showErrorMessage(error);
                });
            });
        },
        hasCommentError(key) {
            return Object.keys(this.commentErrors).includes(key);
        },
        clearCommentErrors() {
            this.commentErrors = [];
        },
        createComment: function() {
            this.checkAuthenticationAndThen(() => {

                // do nothing if already commenting
                if(this.isCommenting){
                    return;
                }

                this.isCommenting = true;

                axios.post(route('web-api.posts.comment', this.post.id), {
                    text: this.comment,
                }).then((response) => {

                    // add post comment to ui
                    const postComment = response.data.post_comment;
                    if(postComment){
                        this.comments.push(postComment);
                    }

                    // clear text from input field
                    this.comment = "";
                    this.clearCommentErrors();

                }).catch((error) => {

                    // update errors
                    this.errors = error.response?.data?.errors;

                    this.showErrorMessage(error);

                }).then(() => {
                    this.isCommenting = false;
                });

            });

        },
        deleteComment: function(postComment) {

            // ask user to confirm
            if(!confirm("Are you sure you want to delete this comment?")){
                return;
            }

            axios.delete(route('web-api.posts.comments.delete', postComment)).then((response) => {

                const json = response.data;

                // show message
                window.toastr.info(json.message, null, {
                    positionClass: 'toast-bottom-right',
                });

                // remove post comment from ui
                this.comments = this.comments.filter(function(comment) {
                    return comment.id !== postComment.id;
                });

            }).catch((error) => {
                this.showErrorMessage(error);
            });

        },
        followUser: function() {
            this.checkAuthenticationAndThen(() => {
                axios.post(route('web-api.users.follow', this.post.user.id)).then((response) => {

                    // update ui
                    this.post.is_following = true;

                    // emit event
                    this.$emit('user-followed', this.post.user.id);

                }).catch((error) => {
                    this.post.is_following = false; // revert state so they can try again
                    this.showErrorMessage(error);
                });
            });
        },
        unfollowUser: function() {
            this.checkAuthenticationAndThen(() => {
                axios.post(route('web-api.users.unfollow', this.post.user.id)).then((response) => {

                    // update ui
                    this.post.is_following = false;

                    // emit event
                    this.$emit('user-unfollowed', this.post.user.id);

                }).catch((error) => {
                    this.showErrorMessage(error);
                });
            });
        },
        hideUser: function() {

            // ask user to confirm
            if(!confirm(`Are you sure you want to hide @${this.post.user.username}? We won't show their posts in For You. They will still be shown in the Following tab.`)){
                return;
            }

            axios.post(route('web-api.users.hide', this.post.user.id)).then((response) => {

                // emit event
                this.$emit('user-hidden', this.post.user.id);

            }).catch((error) => {
                this.showErrorMessage(error);
            });

        },
        hidePost: function() {

            // ask user to confirm
            if(!confirm("Are you sure you want to hide this post? We won't show it again in For You. It will still be shown in the Following tab.")){
                return;
            }

            axios.post(route('web-api.posts.hide', this.post.id)).then((response) => {

                // emit event
                this.$emit('post-hidden', this.post.id);

            }).catch((error) => {
                this.showErrorMessage(error);
            });

        },
        pinPost: function() {
            axios.post(route('web-api.v1.posts.pin', this.post)).then((response) => {

                // show message
                window.toastr.info(response.data.message, null, {
                    positionClass: 'toast-bottom-right',
                });

                // update ui
                this.post.is_pinned = response.data.post.is_pinned;

            }).catch((error) => {
                this.showErrorMessage(error);
            });
        },
        unpinPost: function() {

            // ask user to confirm
            if(!confirm('Are you sure you want to Unpin this Post?')){
                return;
            }

            // unpin post
            axios.post(route('web-api.v1.posts.unpin', this.post)).then((response) => {

                // show message
                window.toastr.info(response.data.message, null, {
                    positionClass: 'toast-bottom-right',
                });

                // update ui
                this.post.is_pinned = response.data.post.is_pinned;

            }).catch((error) => {
                this.showErrorMessage(error);
            });

        },
        deletePost: function() {

            // ask user to confirm
            if(!confirm('Are you sure you want to Delete this Post?')){
                return;
            }

            // delete post
            axios.delete(route('web-api.v1.posts.delete', this.post)).then((response) => {

                // show message
                window.toastr.info(response.data.message, null, {
                    positionClass: 'toast-bottom-right',
                });

                // fire deleted event
                this.$emit('deleted');

            }).catch((error) => {
                this.showErrorMessage(error);
            });

        },
        unlockPost: function() {
            this.checkAuthenticationAndThen(() => {
                axios.post(route('web-api.v1.posts.unlock', this.post.id)).then(function(response) {
                    window.location = response.data.redirect;
                }).catch(function(error) {
                    this.showErrorMessage(error);
                });
            });
        },
        onLockedMediaClick: function() {

            // handle pay to view post
            if(this.post.privacy === 'pay_to_view'){
                this.unlockPost();
                return;
            }

            // handle subscribers only post
            if(this.post.privacy === 'subscribers_only'){
                this.showSubscriptionOptionsModal();
                return;
            }

        },
        showErrorMessage: function(error) {

            // determine error message
            var message = error?.response?.data?.message ?? "Something went wrong. Please try again.";

            // show error message
            window.toastr.error(message, null, {
                positionClass: 'toast-bottom-right',
            });

        },
        linkifyHtml: function(html) {
            return window.linkifyHtml(html, null);
        },
        linkifyString: function(str, typesString) {
            return window.linkifyString(str, typesString);
        },
    },
    computed: {
        postColumnSizeClass: function() {

            const mediaCount = this.post.media.length;
            switch(mediaCount){
                case 1: return 'p-1 col-12 col-sm-6 col-xl-4';
                case 2: return 'p-1 col-6 col-lg-4';
                case 3: return 'p-1 col-4';
                case 4: return 'p-1 col-6 col-sm-3';
            }

            if(mediaCount >= 5){
                return 'p-1 col-4 col-md-3 col-lg-2';
            }

            return '';

        },
        orderedMedia: function() {
            return this.post.media.sort((mediaA, mediaB) => {
                return mediaA.order - mediaB.order;
            })
        },
        orderedPreviewMedia: function() {
            return _.take(this.orderedMedia, this.maxPreviewMediaToShow);
        },
        moreMediaCount: function() {
            return this.post.media.length - this.maxPreviewMediaToShow;
        },
    }
}
</script>
